import { type Route } from '!/router'
import { runtime } from '~/app'

// sync routes
import auth from './auth'
import error from './error'

// top-level routes
export default {
  path: '',
  title: () => runtime.app.appName as string,

  children: [
    // service route to show navigation error
    // cound be happen, for example, when action throw an exception
    // should be first, so router resolve will not fail _before_ reach this route
    {
      path: '/error',
      load: error,
    },

    // application top level segments routes
    {
      path: '',
      load: auth,
    },
    {
      path: '',
      load: import('./home'),
    },
    {
      path: '',
      load: import('./home-new'),
    },
    {
      path: '/library',
      load: () => import('./library'),
    },
    {
      path: '/search',
      load: () => import('./search'),
    },
    {
      path: '/movies',
      load: () => import('./movies'),
    },
    {
      path: '/shows',
      load: () => import('./shows'),
    },
    {
      path: '/tv',
      load: () => import('./tv'),
    },
    {
      path: '/events',
      load: () => import('./events'),
    },
    {
      path: '/player',
      load: () => import('./player'),
    },
    {
      path: '/account',
      load: () => import('./account'),
    },
    {
      path: '/terms-of-agreements',
      load: () => import('./terms-of-agreements'),
    },
    {
      path: '/privacy-policy',
      load: () => import('./privacy-policy'),
    },
    {
      path: '/catchups',
      load: () => import('./catchups'),
    },
    {
      path: '/epg',
      load: () => import('./epg'),
    },
    {
      path: '/profiles',
      load: () => import('./profiles'),
    },

    // not found case,
    // must be the last one
    {
      path: '(.*)',
      load: () => import('./404'),
    },
  ],
} satisfies Route
